import { selectors } from 'modules/common';
import { State } from 'modules/data';
import { redirectAndNotify } from 'modules/page/helpers/redirectAndNotify';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useIsBudgetingAvailable } from 'shared/hooks/useIsBudgetingAvailable';

export const usePageData = () => {
    const { companyId } = useParams<{ companyId: string }>();
    const company = useSelector((state: State) => selectors.company.getCompanyById(state, companyId));
    const isBudgetingAvailable = useIsBudgetingAvailable(company);

    useEffect(() => {
        if (!isBudgetingAvailable) {
            redirectAndNotify();
        }
    }, [isBudgetingAvailable]);
};
